<template>
  <b-container>
    <div v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES]) && periodEnd"><div class="font-weight-bold mb-3">Periodos académicos finalizados</div></div>
    <div v-if="!hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES]) && periodEnd">
      <div class="p-5 font-size-30">
        <div class="font-weight-bold mb-3">Periodos académicos finalizados</div>
        <div>Pronto habilitaremos nuevamente este módulo para que puedas revisar y descargar tus notas.</div>
        <!-- <div class="font-weight-bold font-size-70 mb-1">:D</div> -->
        <router-link to="/" class="btn btn-outline-primary width-100">Home</router-link>
      </div>
    </div>
    <!-- <b-row v-if="dataClass.evaluationSystem==='QUANTITATIVE'">
      <div class="p-5 font-size-30">
        <div class="font-weight-bold mb-3">Período de exámenes/proyectos semestrales</div>
        <div class="font-size-14 mb-3">Eroo estará habilitado para asignaturas de los grados 8<font face="Arial,Helvetica,sans-serif">º</font> a 11<font face="Arial,Helvetica,sans-serif">º</font> el 5 y 6 de julio.</div>
      <router-link to="/classes" class="btn btn-outline-primary width-100">Go Back</router-link>
      </div>
    </b-row> -->
    <b-row class="justify-content-md-center" v-if="!periodEnd">
      <div class="card" style="max-width: 70rem;">
        <div class="card-header card-header-flex" style="width: 100%; overflow-x: auto; overflow-y: hidden;">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5 class="mb-0 mr-4" style="min-width: max-content;">{{ dataClass.subject.name}}</h5>
          </div>
          <a-tabs defaultActiveKey="2" class="kit-tabs-bold" @change="changeTab">
            <!-- <a-tab-pane tab="Tablero" key="1"  v-if="teacherEditableView"/> -->
            <a-tab-pane v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])" tab="Indicadores" key="4" />
            <a-tab-pane tab="Calificaciones" key="2" />
            <a-tab-pane tab="Global" key="3" />
          </a-tabs>
        </div>
        <div v-show="tabActive == 1">
          <div class="row">
            <div class="col">
              <div id="portada">
                <img class="img-portada" :src="dataClass.pathBanner" alt="">
                <div id="img-description">
                  <h4 class=""><b>Docente</b>: {{ dataClass.tenuredTeacher.fullName }} </h4>
                  <h4 class=""><b>Periodo</b>: {{ dataClass.namePeriodo}} </h4>
                  <h4 v-if="!isElective" class=""><b>Grupo</b>: {{ dataClass.group.name }} </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="grow card v-sheet theme--light elevation-2" file="v-card/usage">
                  <div class="card-body">
                    <h4 class="card-title">Próximas entregas</h4>
                    <p class="card-description">No tienes ninguna tarea para esta semana</p>
                    <div class="row">
                      <b-col  sm="auto" class="align-self-end text-right">
                        <button type="button" class="btn btn-light" disabled>Ver todo</button>
                      </b-col>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8 col-sm-12 custom-mt-xs-4 mt-sm-4 mt-md-0">
                <div class="grow card v-sheet theme--light elevation-2" file="v-card/usage">
                  <div class="card-body">
                    <h4 class="card-title">Para</h4>
                    <div class="dropdown">
                      <a class="btn btn-light dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Todos los alumnos
                      </a>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item" href="#">Todos los alumnos</a>
                      </div>
                    </div>
                    <br>
                    <div>
                      <b-form-textarea
                        id="textarea"
                        placeholder="Mensaje..."
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                    </div>
                    <br>
                    <!-- <v-textarea name="input-7-1" label="Mensaje para la clase"></v-textarea> -->
                    <!-- <p class="card-description">No tienes ninguna tarea para esta semana</p> -->
                    <div class="row">
                      <div class="col">
                        <button type="button" class="btn btn-light btn-icon-text" disabled>
                          <i class="mdi mdi-library-plus btn-icon-prepend"></i>
                          Adjundar
                        </button>
                      </div>
                      <div class="col align-self-end text-right">
                        <button type="button" class="btn btn-light btn-icon-text" disabled>
                          <i class="mdi mdi-send btn-icon-prepend"></i>
                          Publicar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tabActive == 4">
          <div style="width: 70rem;"></div>
          <div class="card-body">
            <b-row>
              <b-col sm="12" md="6">
                <h4 class=""><b>Docente</b>: {{ dataClass.tenuredTeacher.fullName }} </h4>
                <h4 class=""><b>Periodo</b>: {{ dataClass.namePeriodo}} </h4>
                <h4 v-if="!isElective" class=""><b>Grupo</b>: {{ dataClass.group.name }} </h4>
              </b-col>
              <b-col sm="12" md="6" v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])">
                  <p class="text-right">
                    {{ checkTimeLeft }}
                  </p>
                  <p class="text-muted text-right">
                    Última modificación: {{ lastUpdated }}
                  </p>
                  <p class="text-right">
                    <b-form-checkbox v-model="autoSave" name="check-button" switch :disabled="!teacherEditableView">Autoguardado</b-form-checkbox>
                  </p>
                  <p class="text-right">
                    <b-button variant="primary" :disabled="!isRecentChanges" v-show="!autoSave" @click="saveGrades()">
                      <i class="fe fe-save mr-1" aria-hidden="true"></i>Guardar
                    </b-button>
                  </p>
              </b-col>
            </b-row>
            <a-divider/>
            <b-row class="text-center mt-2" v-show="showSkeleton">
              <b-col md="6" offset-md="3">
                <div>
                  <a-skeleton active/>
                </div>
              </b-col>
            </b-row>
            <performanceIndicators @updatedAt="recieveUpdatedAt" :dataInfo="dataQualificationsToSend" :isElective="isElective ? true : false" :currentPeriod="currentPeriod" :idClass="this.dataClass.id" :teacherEditableView="this.teacherEditableView"/>
          </div>
        </div>
        <div v-show="tabActive == 2">
          <div style="width: 70rem;"></div>
          <div class="card-body">
            <b-row>
              <b-col sm="12" md="6">
                <h4 class=""><b>Docente</b>: {{ dataClass.tenuredTeacher.fullName }} </h4>
                <h4 class=""><b>Periodo</b>: {{ dataClass.namePeriodo}} </h4>
                <h4 v-if="!isElective" class=""><b>Grupo</b>: {{ dataClass.group.name }} </h4>
              </b-col>
              <b-col sm="12" md="6" v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])">
                  <p class="text-right">
                    {{ checkTimeLeft }}
                  </p>
                  <p class="text-muted text-right">
                    Última modificación: {{ lastUpdated }}
                  </p>
                  <p class="text-right">
                    <b-form-checkbox v-model="autoSave" name="check-button" switch :disabled="!teacherEditableView">Autoguardado</b-form-checkbox>
                  </p>
                  <p class="text-right">
                    <b-button variant="primary" :disabled="!isRecentChanges" v-show="!autoSave" @click="saveGrades()">
                      <i class="fe fe-save mr-1" aria-hidden="true"></i>Guardar
                    </b-button>
                  </p>
              </b-col>
            </b-row>
            <b-row class="text-center">
              <b-col>
                <div style="overflow-x: scroll;">
                  <div id="spreadsheet" ref="spreadsheet"></div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <div v-show="tabActive == 3">
          <div style="width: 70rem;"></div>
          <div class="card-body">
            <b-row>
              <b-col sm="12" md="6">
                <h4 class=""><b>Docente</b>: {{ dataClass.tenuredTeacher.fullName }} </h4>
                <h4 class=""><b>Periodo</b>: {{ dataClass.namePeriodo}} </h4>
                <h4 v-if="!isElective" class=""><b>Grupo</b>: {{ dataClass.group.name }} </h4>
              </b-col>
            </b-row>
            <b-row class="text-center">
              <b-col>
                <div style="overflow-x: scroll;">
                  <div id="spreadsheetTotal" ref="spreadsheetTotal"></div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
// import emptyTable from '@/components/custom/cardEmptyList'
import { hasPermission, consts, hasRole, showErrorMessage } from '@/services/utilities'
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import { mapState } from 'vuex'
import axios from 'axios'
import jexcelStyle from 'jexcel/dist/jexcel.css' // eslint-disable-line no-unused-vars
import jexcel from 'jexcel'
import Swal from 'sweetalert2'
import moment from 'moment'
import performanceIndicators from '@/components/custom/performanceIndicators'
import store from '@/store'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 8000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  components: {
    // emptyTable,
    performanceIndicators,
  },
  name: 'ClassRoomTBG',
  data() {
    var self = this
    return {
      indicatorVisible: false,
      indicator: [],
      columns: [
        { key: 'id', label: 'Código' },
        { key: 'description', label: '' },
      ],
      timerId: 0,
      tableLength: '',
      jExcelObj: {},
      gradesExcel: {},
      teacherEditableView: false,
      dataClass: {
        subject: {
          name: '',
        },
        group: {
          name: '',
        },
        tenuredTeacher: {
          fullName: '',
        },
      },
      dataQualificationsToSend: '',
      tabActive: 2,
      autoSave: true,
      showSkeleton: false,
      currentPeriod: '',
      isRecentChanges: false,
      lastUpdated: '',
      isElective: false,
      periodFinalDate: '',
      checkTimeLeft: '',
      periodEnd: true,
      timer: null,
      intervalTimer: 1000,
      options: {
        // style: {
        //   A1: 'background-color: #F3F3F3;',
        //   B1: 'background-color: #F3F3F3;',
        // },
        updateTable: function (instance, cell, col, row, val, label, cellName) {
          if (row % 2 === 1) {
            cell.style.backgroundColor = '#f3f3f3'
          }
          if (col === 0 || col === 1) {
            cell.style.color = '#000000'
          }
        },
        minDimensions: [3, 1],
        allowInsertRow: false,
        allowInsertColumn: false,
        onchange: self.changed,
        onselection: self.selectionActive,
        onload: self.loaded,
        onbeforechange: self.beforeChange,
        onafterchanges: self.afterchanges,
        onchangeheader: self.changeheader,
        allowDeleteRow: false,
        allowDeleteColumn: false,
        rowDrag: false,
        columnDrag: false,
        columnSorting: false,
        contextMenu: function (obj, x, y, e) {
          const items = []
          if (obj.options.allowExport) {
            items.push({
              title: obj.options.text.saveAs,
              shortcut: 'Ctrl + S',
              onclick: function () {
                obj.download()
              },
            })
          }
          if (obj.options.allowRenameColumn) {
            items.push({
              title: obj.options.text.renameThisColumn,
              onclick: function() {
                obj.setHeader(x)
              },
            })
          }
          return items
        },
      },
      options2: {
        // style: {
        //   A1: 'background-color: #F3F3F3;',
        //   B1: 'background-color: #F3F3F3;',
        // },
        updateTable: function (instance, cell, col, row, val, label, cellName) {
          if (row % 2 === 1) {
            cell.style.backgroundColor = '#f3f3f3'
          }
          if (col === 0 || col === 1) {
            cell.style.color = '#000000'
          }
        },
        minDimensions: [3, 1],
        allowInsertRow: false,
        allowRenameColumn: false,
        allowInsertColumn: false,
        onchange: self.changed,
        onload: self.loaded,
        allowDeleteRow: false,
        allowDeleteColumn: false,
        rowDrag: false,
        columnDrag: false,
        columnSorting: false,
        contextMenu: function (obj, x, y, e) {
          const items = []
          if (obj.options.allowExport) {
            items.push({
              title: obj.options.text.saveAs,
              shortcut: 'Ctrl + S',
              onclick: function () {
                obj.download()
              },
            })
          }
          return items
        },
      },
      consts: consts,
      idRoles: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    const isElective = to.query.elective
    let elective = isElective ? '?elective=true' : '?elective=false'
    if (to.params.childSelected !== null) {
      elective = elective + '&childSelected=' + to.params.childSelected
    }

    function getDataClass() {
      if (!isElective) {
        return apiClient.get('/group-subjects/' + to.params.idClass)
      } else {
        return apiClient2.get('/electives/' + to.params.idClass)
      }
    }

    function getQualifications() {
      return apiClient.get(`qualifications/tbg/classes/${to.params.idClass + elective}`)
    }

    function getPeriodsQualifications() {
      return apiClient.get(`qualifications/tbg/classes/${to.params.idClass}/total${elective}`)
    }

    axios.all([getDataClass(), getQualifications(), getPeriodsQualifications()])
      .then(axios.spread(function (dataClass, dataQualifications, setDataPeriodsQualifications) {
        next((vm) => {
          vm.setDataClass(null, dataClass.data, isElective)
          vm.setDataQualifications(null, dataQualifications.data)
          vm.setDataPeriodsQualifications(null, setDataPeriodsQualifications.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataClass(err, [])
          vm.setDataQualifications(err, [])
          vm.setDataPeriodsQualifications(err, [])
        })
      })
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    options: {
      handler: function (after, before) {
        console.log(after)
      },
      deep: true,
    },
    options2: {
      handler: function (after, before) {
        console.log(after)
      },
      deep: true,
    },
  },
  methods: {
    recieveUpdatedAt(updatedAt) {
      this.lastUpdated = updatedAt
    },
    onHidden (e) {
      this.$bvModal.hide('performanceIndicator')
      this.indicator = []
    },
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    timeLeft() {
      if (this.periodFinalDate !== null) {
        const now = moment()
        const finalDate = moment(this.periodFinalDate)
        if (finalDate.diff(now, 'days') < 21) {
          this.checkTimeLeft = 'Quedan ' + finalDate.diff(now, 'days') + ' días y ' + moment.duration(finalDate.diff(now)).hours() + ' horas para cerrar el periodo'
        } else if (finalDate.diff(now, 'seconds') < 1) {
          this.checkTimeLeft = 'Periodo finalizado'
        }
        this.periodEnd = finalDate.diff(now, 'seconds') < 1
      }
    },
    setDataClass(err, dataClass, isElective) {
      if (err) {
        this.error = err.toString()
      } else {
        this.isElective = isElective
        this.dataClass = (isElective) ? dataClass.data.data : dataClass.data
        this.tabActive = 2
        // Y POR ULTIMO VALIDAR LO MISMO EN LOS DIFERENTES ENDPOINTS DEL SERVER
        // TODO Entender la diferencia entre (this.$store.state.user), (...mapState(['user']) //this.user), (JSON.parse(store.get('userData')))
        if ((this.dataClass.idAssistantTeacher === this.$store.state.user.id || this.dataClass.idTenuredTeacher === this.$store.state.user.id || hasRole(this.idRoles, consts.roles.ADMIN_ACADEMICO) || hasRole(this.idRoles, consts.roles.COORDINADOR)) &&
        hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES], this.$store.state.user.permissions)) {
          this.teacherEditableView = true
        } else {
          this.teacherEditableView = false
        }
      }
    },
    setDataQualifications(err, dataQualifications) {
      if (err) {
        this.error = err.toString()
      } else {
        this.dataQualificationsToSend = {
          performanceList: dataQualifications.performanceList,
          options: dataQualifications.performanceTable.options,
          period: dataQualifications.period,
          observationList: dataQualifications.observationList,
        }
        this.currentPeriod = dataQualifications.period.id
        this.periodFinalDate = dataQualifications.period.finalDate
        this.options.data = dataQualifications.options.data
        this.options.includeHeadersOnDownload = dataQualifications.options.includeHeadersOnDownload
        this.options.operator = dataQualifications.options.operator
        this.options.automatic = dataQualifications.options.automatic
        this.options.nestedHeaders = dataQualifications.options.nestedHeaders
        this.options.columns = dataQualifications.options.columns
        this.lastUpdated = dataQualifications.lastUpdated
        const jExcelObj = jexcel(this.$refs.spreadsheet, this.options)
        this.jExcelObj = Object.assign({}, jExcelObj)
        this.tableLength = this.jExcelObj.getConfig()
        this.tableLength = this.tableLength.columns.length - 10
      }
    },
    setDataPeriodsQualifications(err, dataPeriodsQualifications) {
      if (err) {
        this.error = err.toString()
      } else {
        this.options2.data = dataPeriodsQualifications.options.data
        this.options2.includeHeadersOnDownload = dataPeriodsQualifications.options.includeHeadersOnDownload
        this.options2.operator = dataPeriodsQualifications.options.operator
        this.options2.automatic = dataPeriodsQualifications.options.automatic
        this.options2.nestedHeaders = dataPeriodsQualifications.options.nestedHeaders
        this.options2.columns = dataPeriodsQualifications.options.columns
        const gradesExcel = jexcel(this.$refs.spreadsheetTotal, this.options2)
        this.gradesExcel = Object.assign({}, gradesExcel)
      }
    },
    onTabChange(key, type) {
      console.log(key, type)
      this[type] = key
    },
    changeTab(key) {
      console.log(key)
      this.tabActive = key
    },
    beforeChange(instance, cell, x, y, value) { // Validations
      if (value === '') {
        return value
      }
      if (isNaN(parseFloat(value)) || !isFinite(value)) {
        return 0.1
      }
      if (value === '0' || value === '0.0') {
        return 0.1
      }
      value = parseFloat(value).toFixed(1)
      if (value > 10 || value < 0) {
        return ''
      }
      return value
    },
    changed(instance, cell, x, y, value) {
      for (const item of this.options.automatic) {
        if (item.type === 'prom') {
          if ((x >= item.start && x <= item.end)) {
            let average = 0
            let count = 0
            for (let xi = item.start; xi <= item.end; xi++) {
              if (this.jExcelObj.getValueFromCoords(xi, y) !== '') {
                average += parseFloat(this.jExcelObj.getValueFromCoords(xi, y))
                count++
              }
            }
            if (count !== 0) {
              average /= count
            }
            average = average === 0 ? 0.1 : average
            this.jExcelObj.setValueFromCoords(item.col, y, average.toFixed(1), true)
          }
        } else if (item.type === 'percentage') {
          if (item.elements.map(e => e.col).some(e => parseInt(e) === parseInt(x))) {
            let sum = 0
            for (const element of item.elements) {
              if (this.jExcelObj.getValueFromCoords(element.col, y) !== '') {
                sum += (parseFloat(this.jExcelObj.getValueFromCoords(element.col, y)) * (element.p / 100))
              }
            }
            this.jExcelObj.setValueFromCoords(item.col, y, sum, true)
          }
        }
      }
    },
    canUpdate() {
      if (this.dataClass.assistantTeacher === this.$store.state.user.id || this.dataClass.idTenuredTeacher === this.$store.state.user.id ||
        hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES], this.user.permissions)) {
        return true
      } else {
        this.$notification.error({
          message: 'No tiene permisos suficientes',
        })
        return false
      }
    },
    changeheader(instance, col, old, newValue) {
      if (newValue && this.canUpdate()) {
        if (this.isElective) {
          // TODO add this endPoint to the electiveServices
          apiClient2.patch(`electives/${this.dataClass.id}/headers`, { col: col, newValue: newValue }).then(response => {
          }).catch(error => {
            console.log(error)
            this.$notification.error({
              message: 'Ooops ocurrió un error',
              description: showErrorMessage(error),
            })
          })
        } else {
          apiClient.patch(`group-subjects/${this.dataClass.id}/headers`, { col: col, newValue: newValue }).then(response => {
          }).catch(error => {
            console.log(error)
            this.$notification.error({
              message: 'Ooops ocurrió un error',
              description: showErrorMessage(error),
            })
          })
        }
      }
    },
    afterchanges() {
      if (this.autoSave) {
        clearTimeout(this.timerId)
        this.timerId = setTimeout(() => {
          this.saveGrades()
        }, 250)
      } else {
        this.isRecentChanges = true
      }
    },
    saveGrades() {
      apiClient.patch(`qualifications/tbg/classes/${this.dataClass.id}/grades`, { grades: this.options.data, isElective: this.isElective, currentPeriod: this.currentPeriod }).then(response => {
        if (!this.autoSave) {
          this.isRecentChanges = false
          Toast.fire({
            icon: 'success',
            title: 'Cambios guardados.',
          })
        }
        this.lastUpdated = response.data.lastUpdated
      }).catch(error => {
        console.log(error)
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
  },
  created() {
    if (this.periodFinalDate !== null) {
      const now = moment()
      const finalDate = moment(this.periodFinalDate)
      if (finalDate.diff(now, 'days') < 21) {
        this.checkTimeLeft = 'Quedan ' + finalDate.diff(now, 'days') + ' días y ' + moment.duration(finalDate.diff(now)).hours() + ' horas para cerrar el periodo'
      } else if (finalDate.diff(now, 'seconds') < 1) {
        this.checkTimeLeft = 'Periodo finalizado'
      }
      this.periodEnd = finalDate.diff(now, 'seconds') < 1
    }
    this.timer = setInterval(() => {
      this.timeLeft()
      return this.intervalTimer
    }, this.intervalTimer)
    this.idRoles = JSON.parse(store.get('userData')).idRoles
  },
  beforeDestroy() {
    this.intervalTimer = 30000
    clearInterval(this.timer)
  },
}
</script>
<style lang="scss">
@import "./style.module.scss";
</style>
